/**
 * GiftCardLedgerRowAmount — a ledger row's signed amount plus the running
 * balance the card held immediately after it (BON-223).
 */
import { formatMoney } from '../review/reviewQueueModel';

export function GiftCardLedgerRowAmount({
  amountCents,
  balanceCents,
  currency,
}: {
  amountCents: number;
  balanceCents: number;
  currency: string;
}) {
  const credit = amountCents > 0;
  return (
    <div style={{ flex: '0 0 auto', textAlign: 'right' }}>
      <div
        className="nb-tabular"
        style={{
          fontSize: 13.5,
          fontWeight: 800,
          color: credit ? 'var(--nb-primary-2)' : 'var(--nb-ink)',
        }}
      >
        {credit ? '+' : '−'}
        {formatMoney(Math.abs(amountCents), currency)}
      </div>
      <div className="nb-tabular" style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>
        bal {formatMoney(balanceCents, currency)}
      </div>
    </div>
  );
}
